"use client"

import { toast } from "sonner"
import type { NotificationType } from "@/types/notification"

const TOAST_DEDUPE_WINDOW_MS = 8000
const recentToastKeys = new Map<string, number>()

function pruneExpiredToastKeys(now: number) {
  for (const [key, expiresAt] of recentToastKeys.entries()) {
    if (expiresAt <= now) {
      recentToastKeys.delete(key)
    }
  }
}

export function showInAppNotificationToast(options: {
  type: NotificationType
  title: string
  message: string
  dedupeKey: string
}) {
  const now = Date.now()
  pruneExpiredToastKeys(now)

  if (recentToastKeys.has(options.dedupeKey)) {
    return
  }

  recentToastKeys.set(options.dedupeKey, now + TOAST_DEDUPE_WINDOW_MS)

  const toastFn = options.type === "task_overdue" ? toast.warning : toast.info
  toastFn(options.title, {
    description: options.message,
    duration: 6000,
  })
}
